import { render, staticRenderFns } from "./_categoriesEcommerceFilter.vue?vue&type=template&id=021dfdb4&"
import script from "./_categoriesEcommerceFilter.vue?vue&type=script&lang=js&"
export * from "./_categoriesEcommerceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports